export default __webpack_public_path__ + "56fcb384e403ca7fa3e6dd785ce7a7b5.png";